import React from "react";

const GenericSmallIcon = () => {
  return (
    <svg
      width="24"
      height="16"
      viewBox="0 0 24 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="Credit card"
    >
      <rect width="24" height="16" rx="2" fill="#15749D" />
      <path
        d="M6.66663 11.5555C7.03482 11.5555 7.33362 11.8543 7.33362 12.2225C7.33344 12.5906 7.03471 12.8885 6.66663 12.8885H3.33362C2.96554 12.8885 2.6668 12.5906 2.66663 12.2225C2.66663 11.8543 2.96543 11.5555 3.33362 11.5555H6.66663ZM15.3336 11.5555C15.7017 11.5557 15.9996 11.8545 15.9996 12.2225C15.9995 12.5905 15.7015 12.8884 15.3336 12.8885H9.33362C8.96554 12.8885 8.6668 12.5906 8.66663 12.2225C8.66663 11.8543 8.96543 11.5555 9.33362 11.5555H15.3336Z"
        fill="#E4F4FD"
      />
      <path
        d="M16 7.56903H17.3154V8.66669H17C16.4477 8.66669 16 8.21897 16 7.66669V7.56903ZM19.1016 7.56903V8.66669H17.5654V7.56903H19.1016ZM20.667 7.66669C20.667 8.21885 20.2191 8.66649 19.667 8.66669H19.3516V7.56903H20.667V7.66669ZM16 6.23602H17.3154V7.31903H16V6.23602ZM20.667 7.31903H19.3516V6.23602H20.667V7.31903ZM19.1016 6.23602V7.31903H17.5654V6.23602H19.1016ZM17.3154 4.66669V5.98602H16V5.66669C16 5.1144 16.4477 4.66669 17 4.66669H17.3154ZM19.1016 4.66669V5.98602H17.5654V4.66669H19.1016ZM19.667 4.66669C20.2191 4.66688 20.667 5.11452 20.667 5.66669V5.98602H19.3516V4.66669H19.667Z"
        fill="#F4C932"
      />
    </svg>
  );
};

export default GenericSmallIcon;
